// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/batamp/" + chunkId + "." + {"109":"baa5f307f37922e47c8b","234":"ba329eefad770787caa2","239":"27af907f0b9728c6948a","508":"1bcd6bcfcefc3055e190","765":"6b2959163df31bd81b1e","837":"2dea64fc5ac44e385b0f"}[chunkId] + ".js";
};